// extracted by mini-css-extract-plugin
module.exports = {"scroll":"scroll-down-module__scroll___GdYQv","scroll-down":"scroll-down-module__scroll-down___UdMer"};